// Added by Sejune Oh on 2020-07-06
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 *  [1] Interface
 *  [2] Type
 *  [3] Enum
 *  [4] Constants
 */

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [1] Interface
export interface SiteConfig {
  key: string,
  value: string,
  type: string,
  possible_values: string
  description: string
  license_keys: string
  default_value: string
  overridable_on_ds: boolean
  ds_overrided: boolean
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [2] Type
export type SiteConfigOption = {
  // Group
  [key: string]: {
    // Option
    [key: string]: SiteConfig
  }
}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [3] Enum

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [4] Constants
export const SHOW_PATH_IS_VALID = 2000
